<!--崇峰定制采购询价单打印模板-->
<template>
    <div v-loading="loading" style="min-height: 400px">
        <div id="printContent" style="color: #000">
            <div :key="index" v-for="(item, index) in printList">
                <div class="print-title">供应商询价单</div>
                <div class="company">单位：{{ company }}</div>
                <div class="print-table-main">
                    <el-table :data="item.DetailList" :span-method="objectSpanMethod" class="fkyou" border style="width: 100%">
                        <el-table-column label="客户名称">
                            <el-table-column label="联系电话">
                                <el-table-column label="期限日期">
                                    <el-table-column label="UNP码" prop="GoodCode" min-width="10%" show-overflow-tooltip>
                                        <template slot-scope="scope">
                                            {{ (scope.row.GoodCode || '').split(',')[0] }}
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column :label="item.EntpCusName">
                            <el-table-column label="">
                                <el-table-column :label="item.NeedTime">
                                    <el-table-column label="汽配编码" prop="APCode" min-width="20%" show-overflow-tooltip> </el-table-column>
                                    <el-table-column label="配件名称" prop="GoodName" min-width="20%" show-overflow-tooltip> </el-table-column>
                                    <el-table-column label="车型" prop="AutoSerise" min-width="20%" show-overflow-tooltip> </el-table-column>
                                    <el-table-column label="数量" prop="Count" min-width="10%" show-overflow-tooltip> </el-table-column>
                                    <el-table-column label="单位" prop="Unit" min-width="6%" show-overflow-tooltip> </el-table-column>
                                    <el-table-column label="报价" prop="MarketPrice" min-width="14%" show-overflow-tooltip> </el-table-column>
                                    <!-- <el-table-column label="备注" prop="Remark"  show-overflow-tooltip>
                            </el-table-column>                                                                                         -->
                                </el-table-column>
                            </el-table-column>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
        <div class="dialog-footer">
            <el-button class="btn-primary" @click="lodopPrint" v-if="!isDefaultSet">打印</el-button>
            <el-button class="btn-primary" @click="printedRecord" v-print="'#printContent'" v-else>打印</el-button>
            <el-button @click="cancel()">关闭</el-button>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    components: {},
    props: ['printIds'],
    data() {
        return {
            loading: false,
            allPrice: 0,
            allNum: 0,
            printList: [],
            company: this.$util.getLocalStorage('userMsg').EntpName,
            isPrint: false,
            isPreview: false,
            isDefaultSet: false
        };
    },
    created() {
        this.getConfigByCodes();
    },
    mounted() {
        this.getBJOrder();
    },
    methods: {
        getConfigByCodes() {
            let codes = ['dyyl', 'syllqdysz'];
            this.$util.getSysConfigs(codes).then(data => {
                if (data) {
                    for (let i = 0; i < data.length; i++) {
                        let code = data[i].Code;
                        let result = data[i].Result;
                        switch (code) {
                            case 'dyyl':
                                this.isPreview = result;
                                break;
                            case 'syllqdysz':
                                this.isDefaultSet = result;
                                break;
                        }
                    }
                }
            });
        },
        lodopPrint() {
            let LODOP = this.$lodop.getLodop(); //调用getLodop获取LODOP对象
            if (LODOP) {
                let strBodyStyle = `<style>
.company {
  padding: 20px 0;
}
.print-title { width: 762px;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
}
.dialog-footer {
  text-align: right;
}
.print-table-main {
  width: 762px;
  margin-bottom: 20px;
  font-size: 12px;
} 
.fkyou {
   width: 762px;
  border-right: 1px solid #000;
  border-left: 1px solid #000;
  border-bottom: 1px solid #000;
  margin-bottom: 0px;
  font-size: 14px;
}
.fkyou td {
  padding: 0;
  border-right: 1px solid #000;
  border-top: 1px solid #000;
}
.cell {
    padding-left: 1px;
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: clip;
  }
.fkyou th {
  padding: 2px;
  border: 1px solid #000; 
}
 
.fkyou div {
  color: #000;
}
</style>`;

                let strPrintHtml = strBodyStyle + '<body>' + document.getElementById('printContent').innerHTML + '</body>';
                if (this.printList[0].DetailList.length <= 60) {
                    LODOP.SET_PRINT_PAGESIZE(3, '210mm', '20mm', ''); // 这里3表示纵向打印且纸高“按内容的高度”；580表示纸宽58mm；45表示页底空白4.5mm
                    // top,left,width,height,htmlContent
                    LODOP.ADD_PRINT_HTM('0', '0', '210mm', '100%', strPrintHtml);
                } else {
                    LODOP.SET_PRINT_PAGESIZE(0, '210mm', '286mm', '');
                    // top,left,width,height,htmlContent
                    LODOP.ADD_PRINT_HTM('0', '0', '210mm', '100%', strPrintHtml);
                    LODOP.NEWPAGEA();
                }
                if (this.isPreview) LODOP.PREVIEW();
                //预览
                else LODOP.PRINT(); // 直接打印

                setTimeout(() => {
                    this.printedRecord();
                }, 1000);
            }
        },
        printedRecord() {
            this.loading = true;
            this.$util
                .printedRecord(
                    {
                        OrderId: this.printIds[0],
                        Type: 14
                    },
                    true
                )
                .then(res => {
                    this.isPrint = true;
                    this.loading = false;
                })
                .catch(err => {
                    this.loading = false;
                });
        },
        cancel() {
            this.$emit('closeDialog', this.isPrint);
        },
        getBJOrder() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpInquiryOrder/GetEntpPurInquiryPrint',
                    data: {
                        InquiryId: this.printIds[0]
                    },
                    hideLoading: true
                })
                .then(res => {
                    let _allNum = 0;
                    let _allPrice = 0;
                    let data = res.data;
                    let DetailList = data.DetailList;
                    for (let i = 0; i < DetailList.length; i++) {
                        _allNum += Number(DetailList[i].Count);
                        _allPrice += DetailList[i].Count * DetailList[i].MarketPrice;
                    }
                    this.allNum = _allNum;
                    this.allPrice = _allPrice.toFixed(2);
                    data.DetailList.push({ AutoSerise: '总数量', Count: this.allNum, Unit: '总价', MarketPrice: this.allPrice });
                    data.DetailList.push({ GoodCode: '客户要求', APCode: data.Remark });
                    this.printList.push(res.data);
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            let tableData = this.printList[0];
            if (columnIndex != 0 && tableData && tableData.DetailList && rowIndex == tableData.DetailList.length - 1) {
                return [1, 7];
            }
        }
    }
};
</script>
<style lang="less" scoped>
.company {
    padding: 20px 0;
}
.print-title {
    text-align: center;
    font-size: 20px;
    font-weight: bold;
}
.dialog-footer {
    text-align: right;
}
.print-table-main {
    width: 792px;
    margin-bottom: 20px;
    font-size: 12px;
    .div-table-row {
        border-color: black;
    }
    .div-table-cell {
        border-color: black;
        word-wrap: break-word;
        white-space: normal;
        word-break: break-all;
        height: auto;
        line-height: 30px;
        padding-left: 10px;
    }
}
</style>
<style lang="less">
#printContent {
    // 1.修改每行的背景色为透明色
    .el-table th,
    .el-table tr {
        background: #fff !important;
    }
    .el-table div {
        color: #000;
        font-size: 12px;
    }
    .el-table .cell.el-tooltip {
        overflow: hidden !important;
        text-overflow: clip;
    }
    // 2.修改移入到每行的背景色
    .el-table__body tr:hover > td {
        background: #fff !important;
    }
    // // 3.修改表格边框颜色
    // // 右边和下边
    // .el-table--border:after,
    // .el-table--group:after,
    // .el-table:before {
    //   background-color: #fff !important;
    // }
    // // 左边和上边
    // .el-table--border,
    // .el-table--group {
    //   border-color: #000 !important;
    // }
    // .el-table td,
    // .el-table th.is-leaf {
    // //   border-bottom: 1px solid #000 !important;
    // border: 1px solid #000 !important;
    // }
    // // 头部的下边框
    // .el-table--border th,
    // .el-table--border th.gutter:last-of-type {
    // //   border-bottom: 1px solid #000 !important;
    // border: 1px solid #000 !important;
    //   padding:0;
    //   color: #000 !important;
    // }
    // // 列表中间的竖线
    // .el-table--border td,
    // .el-table--border th {
    // //   border-right: 1px solid #000 !important;
    // border: 1px solid #000 !important;
    //   padding:0;
    //   color: #000 !important;
    // }

    .el-table--border,
    .el-table--group {
        border-color: #000;
    }
    .el-table--border:after,
    .el-table--group:after,
    .el-table:before {
        background-color: #000;
    }
    .el-table td,
    .el-table--border th,
    .el-table th.is-leaf {
        border-bottom-color: #000;
        padding: 0;
    }
    .el-table--border td,
    .el-table--border th {
        border-right-color: #000;
        padding: 0;
    }
    // .el-table table{border:1px solid #000;border-collapse: collapse}//边框行合并
    // .el-table table td{border:1px solid #000;;border-collapse: collapse}
}
</style>
